<template>
  <div class="block case">
    <p class="title">行业案例</p>
    <div class="content">
      <ul class="item flex_between">
        <li>
          <div class="box flexCol_center"><i class="icon icon1"></i></div>
          <h4 class="title_detail">新网银行</h4>
        </li>
        <li>
          <div class="box flexCol_center"><i class="icon icon2"></i></div>
          <h4 class="title_detail">众安保险</h4>
        </li>
        <li>
          <div class="box flexCol_center"><i class="icon icon3"></i></div>
          <h4 class="title_detail">台州政府</h4>
        </li>
        <li>
          <div class="box flexCol_center"><i class="icon icon4"></i></div>
          <h4 class="title_detail">夏娃科技</h4>
        </li>
        <li>
          <div class="box flexCol_center"><i class="icon icon5"></i></div>
          <h4 class="title_detail">杭州妇幼保健院</h4>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
    export default {
        name: "case"
    }
</script>

<style scoped lang="scss">
  .case {
    width: 100%;
    background:#f7f7f7;
    .title{
      padding: 40px 0 30px;
      font-family: 'pingfangBold';
      font-size: 24px;
      color: #272727;
     // margin:0 0 20px;
    }
    .content{
      width:1200px;
      margin:0 auto;
    }
    .icon1 {
      display: inline-block;
      width: 180px;
      height: 30px;
      background: url("../assets/img/product2/case1.png") 0 0 no-repeat;
      background-size: 100%;
    }
    .icon2 {
      display: inline-block;
      width: 180px;
      height: 30px;
      background: url("../assets/img/product2/case2.png") 0 0 no-repeat;
      background-size: 100%;
    }
    .icon3 {
      display: inline-block;
      width: 135px;
      height: 50px;
      background: url("../assets/img/product2/case3.png") 0 0 no-repeat;
      background-size: contain;
    }
    .icon4 {
      display: inline-block;
      width: 180px;
      height: 50px;
      background: url("../assets/img/product2/case4.png") 0 0 no-repeat;
      background-size: 100%;
    }
    .icon5 {
      display: inline-block;
      width: 180px;
      height: 50px;
      background: url("../assets/img/product2/case5.png") 0 0 no-repeat;
      background-size: 100%;
    }
    .box {
      width: 198px;
      height: 110px;
      background: #FFFFFF;
      border: 1px solid #E9E9E9;
      box-shadow: 2px 2px 10px 0 #E9E9E9;
      border-radius: 3px;
      align-items: center;
    }
    h4.title_detail {
      font-size: 18px;
      color: #4A4A4A;
      letter-spacing: 0;
      text-align: center;
      font-weight: normal;
      margin: 15px 0 30px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/case.vue